import axios from './config';

export const downloadReportService = () => {
  return axios.get(`/buy-download`, { responseType: 'blob' });
};
